import React, { useRef } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const getData = (sensores) => {

    const temperatura = sensores.map(item => item.temperatura);
    const turbidez = sensores.map(item => item.turbidez);
    const conductividad = sensores.map(item => item.conductividad);
    const hora = sensores.map(item => item.fecha);
    const intensidad = sensores.map(item => item.intensidad);
    const oleaje = sensores.map(item => item.oleaje);

    return {
        labels: hora,
        datasets: [
            {
                label: 'Temperature',
                data: temperatura,
                borderColor: 'rgb(220, 20, 60)',
                backgroundColor: 'rgba(220, 20, 60, 0.5)',
            },
            {
                label: 'Turbidity',
                data: turbidez,
                borderColor: 'rgb(65, 105, 225)',
                backgroundColor: 'rgba(65, 105, 225, 0.5)',
            },
            {
                label: 'Conductivity',
                data: conductividad,
                borderColor: 'rgb(255, 255, 0)',
                backgroundColor: 'rgba(255, 255, 0, 0.5)',
            },
            {
                label: 'Light intensity',
                data: intensidad,
                borderColor: 'rgb(255, 125, 125)',
                backgroundColor: 'rgba(255, 125, 125, 0.5)',
            },
            {
                label: 'Surf',
                data: oleaje,
                borderColor: 'rgb(0, 255, 0)',
                backgroundColor: 'rgba(0, 255, 0, 0.5)',
            }
        ],
    };
};

const getOptions = () => ({
    responsive: true,
    interaction: {
        mode: 'index',
        intersect: false,
    },
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Relation freshwater node',
        },
    },
});

const Chart = ({ data, chartId }) => {
    const chartRef = useRef(null);

    return (
        <Line
            id={`chart-${chartId}`}
            key={chartId}
            ref={chartRef}
            data={getData(data)}
            options={getOptions()}
        />
    );
};

export default Chart;
